import { colorSet } from '@components/Provider';
import { makeStyles } from '@material-ui/core';

interface Props {
  matches: boolean;
  fullHeight?: boolean;
}

export const useStyles = makeStyles((theme) => ({
  root: {},
  appBar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0px 24px 0px',
    height: 61,
    backgroundColor: colorSet.gray000,
    borderBottom: `1px solid ${colorSet.gray400}`,
    zIndex: theme.zIndex.drawer + 10,
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  },
  appbarTitle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 71,
    cursor: 'pointer',
    '& img': {
      height: 20,
      width: 77
    }
  },
  leftSideDrawerPaper: {
    width: '100%',
    maxWidth: 375,
    borderRight: `1px solid ${colorSet.gray400}`,
    zIndex: theme.zIndex.drawer - 1,
    overflowX: 'hidden',
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
      borderRight: 'unset'
    }
  },
  leftSideDrawerPaperHeaderMargin: {
    height: 61 + 68,
    minHeight: 61 + 68,
    [theme.breakpoints.down('md')]: {
      height: 68,
      minHeight: 68
    }
  },
  leftSideDrawerBottomPadding: {
    [theme.breakpoints.down('md')]: {
      paddingBottom: 56
    }
  },
  main: {
    flexGrow: 1,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%'
  },
  content: {
    backgroundColor: colorSet.gray000,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    height: (props: Props) => {
      if (props.fullHeight) {
        return '100%';
      }

      return props.matches ? `calc(100vh - 56px)` : `calc(100vh - 61px)`;
    },

    minHeight: (props: Props) => {
      if (props.fullHeight) {
        return '100%';
      }

      return props.matches ? `calc(100vh - 56px)` : `calc(100vh - 61px)`;
    }
  },
  contentHeaderMargin: {
    display: ({ matches }: Props) => (matches ? 'none' : 'block'),
    width: '100%',
    height: 61,
    minHeight: 61
  },
  contentShift: {
    marginLeft: 375,
    width: 'calc(100% - 375px)',
    maxWidth: 'calc(100% - 375px)'
  },
  contentShiftRight: {
    width: 'calc(100% - 375px - 70px)',
    maxWidth: 'calc(100% - 375px - 70px)'
  },
  homeContent: {
    backgroundColor: colorSet.gray000,
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  }
}));
